/**
 * Retrieves width of dom element
 *
 * @param  {Element} element
 * @return {number}
 */
export function getElementWidth(element: Element): number {
    const rect = element.getBoundingClientRect();
    return rect.width;
}
